import * as routes from '../routes';
import {
  CollectionDetailsRouteState,
  IntegrationDetailsRouteState,
  OfferDetailsRouteState,
} from '../types';

export const getBackButtonUrl = (
  routeState:
    | OfferDetailsRouteState
    | CollectionDetailsRouteState
    | IntegrationDetailsRouteState,
) => {
  if (!routeState) {
    return routes.root;
  }

  if (routeState.from === 'all-offers') {
    return routes.offers;
  }

  if (routeState.from === 'all-integrations') {
    return routes.integrations;
  }

  if (routeState.from === 'collection-details') {
    return routes.getCollectionPath(routeState.collectionId);
  }

  if (routeState.from === 'similar-offers') {
    return routes.getOfferPath(routeState.offerId);
  }

  if (routeState.from === 'similar-integrations') {
    return routes.getIntegrationPath(routeState.integrationId);
  }

  return routes.root;
};
